
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurance-for-doctors",
      function () {
        return require("private-next-pages/insurance-for-doctors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurance-for-doctors"])
      });
    }
  